/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type ReactNode } from "react";

import { css, jsx } from "@compiled/react";

import { N400 } from "@atlaskit/theme/colors";
import { token } from "@atlaskit/tokens";
const bottomNavStyles = css({
    marginBlockStart: token("space.200", "16px"),
    display: "flex",
    justifyContent: "center"
});
const innerDivStyles = css({
    color: token("color.text", N400),
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
type bottomNavProps = {
    normalText?: string;
    children: ReactNode;
};
export const BottomNav = (text: bottomNavProps) => {
    return (
        <div css={bottomNavStyles}>
            <div css={innerDivStyles}>{text.normalText}&nbsp;</div>
            {text.children}
        </div>
    );
};
